import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('projectsPlanner', ['filters']),

    stateClientId: {
      get () {
        return this.filters.clientId
      },

      set (value) {
        this.setFilterProperty({ property: 'clientId', value })
      }
    },

    stateStage1: {
      get () {
        return this.filters.stages1
      },

      set (value) {
        this.setFilterProperty({ property: 'stages1', value })
      }
    },

    stateStage2: {
        get () {
            return this.filters.stages2
        },

        set (value) {
            this.setFilterProperty({ property: 'stages2', value })
        }
    },

    stateStage3: {
        get () {
            return this.filters.stages3
        },

        set (value) {
            this.setFilterProperty({ property: 'stages3', value })
        }
    },

    stateShowUnconfirmed: {
        get () {
            return this.filters.showUnconfirmed
        },

        set (value) {
            this.setFilterProperty({ property: 'showUnconfirmed', value })
        }
    },

  },

  methods: mapActions('projectsPlanner', ['setFilterProperty'])
}
